import axios from './axios'

export function getUserInfo (params) {
  return axios.get('/client/coda/user', { params })
}
export function getServers (params) {
  return axios.get('/client/server/info', { params })
}
export function getProductList (params) {
  return axios.get('/client/coda/product/list', { params })
}
export function getProduct (params) {
  return axios.get('/client/coda/product/receive', { params })
}
